import {
	Component,
	FacetValue,
	FacetValues,
	FacetValuesList,
	HierarchicalFacetValuesList,
	IValueHierarchy,
	IFacetValueElementKlass,
	IComponentBindings,
	IQuerySuccessEventArgs,
	IHierarchicalFacetOptions,
	Initialization,
	QueryEvents
} from 'coveo-search-ui';
import gtmCapture from './GTM-Capture';
import * as $ from 'jquery';

export class CustomHierarchicalFacet extends Coveo.HierarchicalFacet {
	static ID = 'CustomHierarchicalFacet';
	private scroll: number = null;
	private preventRebuild: boolean = false;
	private el: object;
	private selectAllCaption: string = '*Select all';
	private isRunOnce: Boolean = false;

	constructor(element: HTMLElement, options: IHierarchicalFacetOptions, bindings: IComponentBindings) {
		super(element, options, bindings);
		this.el = element;
		this.bind.onRootElement(QueryEvents.querySuccess, (data: IQuerySuccessEventArgs) => this.handleQuerySuccess(data));
		this.options.marginByLevel = 20;
	}

	public deselectValue(value: FacetValue, deselectChildren?: boolean): void;
	public deselectValue(value: string, deselectChildren?: boolean): void;
	public deselectValue(value: any, deselectChildren = true) {
		this.scroll = $(window).scrollTop();
		super.deselectValue(value, deselectChildren);
	}

	public selectValue(value: any, selectChildren) {
		let valueHierarchy = this.getValueFromHierarchy(value);
		let hasChilds = valueHierarchy.childs && valueHierarchy.childs.length > 0;
		if (!hasChilds) {
			this.preventRebuild = false;
			super.selectValue(value, selectChildren);
		} else {
			this.preventRebuild = true;
		}
	}

	public toggleSelectValue(value: any): void {
		let valueHierarchy = this.getValueFromHierarchy(value);
		let hasChilds = valueHierarchy.childs && valueHierarchy.childs.length > 0;
		if (!hasChilds) {
			this.preventRebuild = false;
			super.toggleSelectValue(value);
		} else {
			this.preventRebuild = true;
		}
	}

	private handleQuerySuccess(data: IQuerySuccessEventArgs) {
		const self = this;
		if (this.scroll !== null) {
			$(window).scrollTop(this.scroll);
			this.scroll = null;
		}
		//set correct title for 'Select all' check box
		$("li.coveo-has-childs", self.el).each(function (index, item) {
			if(!$(item).next("li.coveo-no-childs").length) {
				//no child found
				return;
			}
			// Clone the next child and reuse it for "Select all" checkbox
			let cloned = $(item).next("li.coveo-no-childs").clone();
			let dataValue = cloned.attr('data-value');
			let selectAllSeparatorIdx = (cloned.attr('data-value')) ? dataValue.lastIndexOf('|') : dataValue.length;
			let selectAllIdx = selectAllSeparatorIdx + 1;
			cloned.attr('data-value', dataValue.substr(0, selectAllIdx));
		});
		self.sortUnorderedList($('.CoveoCustomHierarchicalFacet[data-id="countryandregion"] ul'));
	}

	private sortUnorderedList(listWrapper) {
		const self = this;
		const listitems = $('li', listWrapper).get();
		listitems.sort(function(a, b) {
			return $(b).attr('data-value').localeCompare($(a).attr('data-value'));
		});
		$.each(listitems, function(idx, itm) {
			let count = $('.coveo-facet-value-count', $(this));
			let caption = $('.coveo-facet-value-caption', $(this)).text();

			if(count.length !== 0 || caption === self.selectAllCaption){
				//add item with occurrences and "* Select all"
				listWrapper.prepend(itm);
			} else {
				//Remove the element itself and all bound events and jQuery data associated with the elements.
				$(this).remove();
			}
		});
	}

	public insertCharAt (index:number, str:string, value:string) {
		return str.substr(0, index) + value + str.substr(index);
	};

	public addSelectAll(index, item) {
		let $this = this;
		if(!$(item).next("li.coveo-no-childs").length) {
			//no child found
			return;
		}
		// Clone the next child and reuse it for "Select all" checkbox
		let cloned = $(item).next("li.coveo-no-childs").clone();
		let dataValue = cloned.attr('data-value');
		let selectAllSeparatorIdx = (cloned.attr('data-value')) ? dataValue.lastIndexOf('|') : dataValue.length;
		let selectAllIdx = selectAllSeparatorIdx + 1;

		cloned.find('.coveo-facet-value-caption').removeAttr("title").text("*Select all");
		cloned.attr('data-value', dataValue.substr(0, selectAllIdx - 1));
		cloned.find('.coveo-facet-value-count').remove();
		cloned.insertAfter($(item));

		// Get all values that should be selected by "Select all" checkbox
		let currentValue = $(item).attr("data-value");
		let currentValueElement = $this.getValueFromHierarchy(currentValue);
		let children = currentValueElement.childs.filter(c => c.facetValue.occurrences > 0);

		// Add 2nd level children manually, since Coveo doesn't provide full hiarachy (no 'childs' property for nested elements)
		let nestedChilds = [];
		_.each(children, c => {
			let currentChild = $this.getValueFromHierarchy(c.facetValue.value);
			if (currentChild.childs && currentChild.childs.length > 0) {
				let childrenWithOccurrences = currentChild.childs.filter(c => c.facetValue.occurrences > 0);
				nestedChilds = nestedChilds.concat(childrenWithOccurrences);
			}
		});

		children = children.filter(c => c.facetValue.occurrences > 0).concat(nestedChilds);
		let values = children.map(c => c.facetValue.value);
		values.push(currentValue);

		// If at least one child is unselected - "Select all" checkbox should select all, otherwise - unselect all
		let select: boolean = false;
		let unselectedValues = _.any(children, c => c.facetValue.selected == false);
		if (unselectedValues) {
			select = true;
		}

		cloned.find(":checkbox").prop('checked', !select);

		cloned.unbind("click").click(function () {
			if(this.isRunOnce) {
				this.isRunOnce = !this.isRunOnce;
				return;
			}
			if (values.length > 0) {

				if (select) {
					$this.selectMultipleValues(values, true);
				} else {
					$this.deselectMultipleValues(values, true);
					$this.scroll = $(window).scrollTop();
				}

				// Update search results
				$this.keepDisplayedValuesNextTime = true;
				Coveo.executeQuery($this.root);
				$this.preventRebuild = false;
				$this.pushAnalyticData(event, $($this.el));
			}
			this.isRunOnce = !this.isRunOnce;
		});
	}

	private pushAnalyticData(event, $rootFacet){
		const $targetLabel = $(event.target).closest('li');
		const $elValue = $targetLabel.data('value');
		const $elCheckbox = $(event.target).closest('label').find('input[type="checkbox"]');
		const $filterSection = $rootFacet.find('.coveo-facet-header .coveo-facet-header-title');

		if(!$elCheckbox.length) return; //skip for +/- button

		gtmCapture({$elCheckbox, $filterSection, $elValue});
	}

	protected rebuildValueElements() {
		const $this = this;
		if (!this.preventRebuild) {
			super.rebuildValueElements();
			const listWrapper = $($this.element).find('ul');
			$this.sortUnorderedList(listWrapper);

			let parents = $("li.coveo-has-childs", $this.element);
			parents.each($this.addSelectAll.bind($this));

			$(".coveo-has-childs", this.element).find(":checkbox").hide();
			$(".coveo-has-childs", this.element).find(".coveo-facet-value-checkbox").hide();
			$(".coveo-has-childs", this.element).find(".coveo-facet-value-caption").css('padding-left', '0');

			// Invoke Coveo's open/close method when clicking on parent element
			$(".coveo-has-childs", this.element).click(function (event) {
				event.preventDefault();
				$(this).find("div.coveo-has-childs-toggle")[0].click();

				// Refresh the control
				$this.keepDisplayedValuesNextTime = true;
				$this.preventRebuild = false;
				$this.rebuildValueElements();
			});
		}
		$(this.el).find('ul li.coveo-facet-selectable').on('click', function () {
			const $targetLabel = $(event.target).closest('label');
			const $elValue = $targetLabel.find('.coveo-facet-value-caption').text();

			//skip for 'select all' since it was called from cloned elem
			if ($elValue !== $this.selectAllCaption) {
				$this.pushAnalyticData(event, $($this.el));

			}
			if($this.isRunOnce) {
				$this.isRunOnce = !$this.isRunOnce;
				return;
			}
			$this.isRunOnce = !$this.isRunOnce;
		});

	}
}

Initialization.registerAutoCreateComponent(CustomHierarchicalFacet);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/CustomHierarchicalFacet.ts